import React, { Component } from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function GestionProfesional() {
  return <section className="py-20 bg-beige-dark/30 border-y border-beige-dark mt-20 pt-[52px] pb-[52px]" data-id="element-150">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 pt-[0px] pb-[0px] pl-[24px] pr-[24px]" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-153">
            🏗️ ¿QUÉ AGREGA EL PACK DE GESTIÓN PROFESIONAL?
          </h2>
        </div>

        {/* Acelerador de Obra */}
        <div className="bg-white rounded-2xl shadow-md border border-beige-dark overflow-hidden mb-12" data-id="element-154">
          <div className="bg-charcoal text-white p-6 md:p-8" data-id="element-155">
            <h3 className="text-2xl font-serif font-bold flex items-center gap-3" data-id="element-156">
              📋 EL ACELERADOR DE OBRA
            </h3>
            <p className="text-gold mt-2 font-medium" data-id="element-157">
              Contratos, Negociación y Presupuesto Ganador
            </p>
          </div>

          <div className="p-6 md:p-8" data-id="element-158">
            <div className="overflow-x-auto mb-8" data-id="element-159">
              <table className="w-full text-sm text-left min-w-[600px]" data-id="element-160">
                <thead className="bg-beige text-charcoal font-bold" data-id="element-161">
                  <tr data-id="element-162">
                    <th className="px-4 py-3 rounded-tl-lg" data-id="element-163">
                      Situación en la obra
                    </th>
                    <th className="px-4 py-3 text-red-600" data-id="element-164">
                      ❌ Sin Acelerador
                    </th>
                    <th className="px-4 py-3 text-green-600 rounded-tr-lg" data-id="element-165">
                      ✅ Con Acelerador
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-beige-dark" data-id="element-166">
                  {[['El albañil pide más dinero de lo acordado', 'No sabés cómo responder', 'Cláusula de precio fijo — respuesta lista'], ['Llegaron 3 presupuestos muy distintos', 'No sabés cuál elegir', 'Planilla de comparación CI con semáforo'], ['La obra lleva semanas de retraso', 'Sin herramientas para exigir', 'Penalidad contractual ya prevista'], ['El contratista abandona la obra', 'Sin respaldo legal', 'Protocolo de abandono paso a paso'], ['Te piden un adelanto grande', 'No sabés si es normal', 'Regla del 20% máximo con justificación'], ['Algo sale mal y no hay contrato', 'Sin protección', 'Modelo de contrato CI con 8 cláusulas']].map((row, i) => <tr key={i} className="hover:bg-beige/50" data-id="element-167">
                      <td className="px-4 py-3 font-medium text-gray-800" data-id="element-168">
                        {row[0]}
                      </td>
                      <td className="px-4 py-3 text-gray-600" data-id="element-169">{row[1]}</td>
                      <td className="px-4 py-3 text-gray-800 font-medium" data-id="element-170">
                        {row[2]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="bg-beige rounded-xl p-6 border border-beige-dark" data-id="element-171">
              <h4 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-172">
                <CheckCircle2 className="text-green-600" data-id="element-173" /> EL ACELERADOR
                INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-174">
                {['Sistema de Negociación CI — 4 Fases', 'Planilla de Comparación de 3 Presupuestos', 'Modelo de Contrato de Obra Completo y Comentado', '6 Checklists de Verificación por Etapa', 'Protocolo de Resolución de 5 Conflictos Típicos', '14 Modelos de Documentos Listos para Usar', 'Recibo de Pago por Etapa', 'Acta de Recepción Final de Obra'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-175">
                    <CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-176" />
                    <span data-id="element-177">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Director de Obra */}
        <div className="bg-white rounded-2xl shadow-md border border-beige-dark overflow-hidden" data-id="element-178">
          <div className="bg-charcoal text-white p-6 md:p-8" data-id="element-179">
            <h3 className="text-2xl font-serif font-bold flex items-center gap-3" data-id="element-180">
              🔑 EL DIRECTOR DE OBRA
            </h3>
            <p className="text-gold mt-2 font-medium" data-id="element-181">
              Cómo Gestionar Tu Construcción Como un Profesional Sin Serlo
            </p>
          </div>

          <div className="p-6 md:p-8" data-id="element-182">
            <div className="overflow-x-auto mb-8" data-id="element-183">
              <table className="w-full text-sm text-left min-w-[600px]" data-id="element-184">
                <thead className="bg-beige text-charcoal font-bold" data-id="element-185">
                  <tr data-id="element-186">
                    <th className="px-4 py-3 rounded-tl-lg" data-id="element-187">
                      Situación en la obra
                    </th>
                    <th className="px-4 py-3 text-red-600" data-id="element-188">❌ Sin Director</th>
                    <th className="px-4 py-3 text-green-600 rounded-tr-lg" data-id="element-189">
                      ✅ Con Director
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-beige-dark" data-id="element-190">
                  {[['La obra avanza cuando el albañil quiere', 'Sin control de avance real', 'Cronograma con buffer CI y control semanal'], ['El presupuesto crece sin explicación', 'Sin herramientas para detectarlo', 'Flujo de caja semanal con 4 alertas tempranas'], ['Los materiales se agotan en plena obra', 'Obra paralizada y costos extra', 'Sistema de abastecimiento en 3 niveles'], ['Calidad descubierta cuando ya no tiene solución', 'Sin protocolo de verificación', 'Kit de verificación sin título universitario'], ['El cierre de obra deja pendientes', 'Sin protocolo de cierre', 'Protocolo de 30 días con acta final'], ['No sabés cuánto llevás gastado', 'Sin registro financiero', 'Planilla de seguimiento semanal']].map((row, i) => <tr key={i} className="hover:bg-beige/50" data-id="element-191">
                      <td className="px-4 py-3 font-medium text-gray-800" data-id="element-192">
                        {row[0]}
                      </td>
                      <td className="px-4 py-3 text-gray-600" data-id="element-193">{row[1]}</td>
                      <td className="px-4 py-3 text-gray-800 font-medium" data-id="element-194">
                        {row[2]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>

            <div className="bg-beige rounded-xl p-6 border border-beige-dark" data-id="element-195">
              <h4 className="font-bold text-lg mb-4 flex items-center gap-2" data-id="element-196">
                <CheckCircle2 className="text-green-600" data-id="element-197" /> EL DIRECTOR INCLUYE:
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-198">
                {['Plan Maestro de Obra — Los 6 Componentes', 'Cronograma con Buffers CI por Estación del Año', 'Flujo de Caja Semanal con Alertas Tempranas', 'Sistema de Abastecimiento en 3 Niveles', 'Kit de Verificación de Calidad Sin Título', 'Protocolo de Cierre de Obra — Los Últimos 30 Días', '11 Modelos de Documentos del Director CI', 'Autoevaluación Mensual del Director CI'].map((item, i) => <div key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-199">
                    <CheckCircle2 className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-200" />
                    <span data-id="element-201">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}